<script setup lang="ts">
import { type PropType, computed } from 'vue'
import type { PaginationOptions } from 'swiper/types'
import { Pagination } from 'swiper/modules'
import 'swiper/css/pagination'
import type {
  FloorHouseModelPanoramaListVO,
  FloorHouseModelPhotoVO,
  FloorHouseModelSampleRoomPhotoListVO,
} from '~/server/newhouse/interface'

const props = defineProps({
  list: {
    type: Array as PropType<FloorHouseModelSampleRoomPhotoListVO[] | FloorHouseModelPhotoVO[] | FloorHouseModelPanoramaListVO[]>,
    default: () => [],
  },
  typeList: {
    type: Array as PropType<{ type: string, len: number, photoList: any[] }[]>,
    default: () => [],
  },
})
const route = useRoute()
const floorId = computed(() => Number(route.params.floorId))
const houseModelId = computed(() => Number(route.params.houseModelId))
const domain = computed(() => route.params.domain)
const picVr = '//imgf1.fccs.com.cn/newhouse-mobile/floor-detail/pic-vr.png'
const photoSwiperRef = ref()
const modules = [Pagination]
const pagination: PaginationOptions = {
  type: 'custom',
  horizontalClass: 'swp-horizontal',
  renderCustom: (swiper, current, total) => {
    return `<span class="swp-custom">${current}/${total}</span>`
  },
}
// 大类别索引
const largeIndex = ref(0)
//  前往相册orVr
function gotoDetail(data: FloorHouseModelSampleRoomPhotoListVO | FloorHouseModelPhotoVO | FloorHouseModelPanoramaListVO) {
  if (data.panoramaUrl) {
    window.open(data.panoramaUrl)
  }
  else {
    //  去楼盘相册
    window.location.href = `/${domain.value}/newhouse/${floorId.value}/photo.html?typename=housemodel&houseModelId=${houseModelId.value}`
  }
}
// 轮播切换-子索引变化影响大类索引
function onSlideChange(swiper: any) {
  const nextIndex = swiper.realIndex
  let tempNextIndex = 0
  let tempPreIndex = 0
  for (let i = 0; i <= largeIndex.value; i++) {
    tempNextIndex = tempNextIndex + props.typeList[i].len
    if (i < largeIndex.value) {
      tempPreIndex = tempPreIndex + props.typeList[i].len
    }
  }
  if (nextIndex > (tempNextIndex - 1)) {
    //  下一页
    largeIndex.value++
  }
  else if (nextIndex <= (tempPreIndex - 1)) {
    //  上一页
    largeIndex.value--
  }
}
//  改变大类索引
function handlerChangeIargeIndex(index: number) {
  let tempIndex = 0
  for (let i = 0; i < index; i++) {
    tempIndex = tempIndex + props.typeList[i].len
  }
  largeIndex.value = index
  photoSwiperRef.value.slideTo(tempIndex)
}
</script>

<template>
  <div class="relative h-600px">
    <Swiper
      :modules="modules"
      class="w-100% h-100%"
      :list="list" :pagination="pagination"
      @swiper="(swiper) => photoSwiperRef = swiper"
      @slide-change="onSlideChange"
    >
      <template #default="{ data }">
        <van-image
          fit="cover"
          position="center"
          width="100%"
          height="100%"
          :src="$getImageSize(data?.panoramaPhotoUrl || data?.photo || data, 'c750x600')"
          @click="gotoDetail(data)"
        />
        <van-image
          v-show="data?.panoramaUrl"
          class="pic-vr"
          :src="picVr"
          @click="gotoDetail(data)"
        />
      </template>
    </Swiper>

    <div v-if="typeList?.length > 1" class="tabs">
      <div
        v-for="(item, index) in typeList" :key="index"
        :class="`tabs-item ${index === largeIndex ? 'tabs-item-active' : ''}`"
        @click.stop="handlerChangeIargeIndex(index)"
      >
        {{ item.type }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
:deep(.swp-horizontal) {
  &:after {
    content: '';
    display: table;
    clear: both;
  }
}
:deep(.swp-custom) {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 196px;
  height: 36px;
  position: absolute;
  bottom: 24px;
  right: 26px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 36px;
  padding: 0 16px;
}
.tabs {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  justify-content: center;
  z-index: 10;
  margin-bottom: 28px;

  &-item {
    background: #fff;
    border: 2px solid $c1DA838;
    padding: 8px 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: $fz4;
    color: $c1DA838;

    &-active {
      color: #fff;
      background: $c1DA838;
    }

    &:not(:first-of-type) {
      border-left: none;
    }

    &:first-of-type {
      border-radius: 8px 0 0 8px;
    }

    &:last-of-type {
      border-radius: 0 8px 8px 0;
    }
  }
}
.pic-vr{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 112px;
  height: 112px;
  object-fit: cover;
}
</style>
